import {
  PENDING_LIST_FAILED,
  PENDING_LIST_INVALID_REQUEST,
  PENDING_LIST_SUCCESS,
  PENDING_LIST_NOT_FOUND,
  NETWORK_ERROR_PENDING_LIST,
  RESET_PENDING_LIST,
  RESET_SEND_PENDING_LIST,
  RESET_CANCEL_PENDING_LIST,
  SEND_PENDINGLIST_FAILED,
  SEND_PENDINGLIST_SUCCESS,
  SEND_PENDINGLIST_INVALID_REQUEST,
  SEND_PENDINGLIST_INSUFFICIENT_BALANCE,
  NETWORK_ERROR_SEND_PENDING_LIST,
  CANCEL_PENDINGLIST_FAILED,
  CANCEL_PENDINGLIST_INVALID_REQUEST,
  CANCEL_PENDINGLIST_SUCCESS,
  NETWORK_ERROR_CANCEL_PENDING_LIST,
} from "../types";

const initialState = {
  success: false,
  failed: false,
  invalidRequest: false,
  sendInvReq: false,
  sendSuccess: false,
  sendFailed: false,
  cancelFailed: false,
  cancelSuccess: false,
  cancelInvReq: false,
  insufficientBalance: false,
  successData: {},
  status: "",
  notFound: "",
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PENDING_LIST_FAILED:
      return {
        ...state,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        failed: true,
        status: "",
        notFound: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        data: action.payload,
      };
    case PENDING_LIST_INVALID_REQUEST:
      return {
        ...state,
        success: false,
        invalidRequest: true,
        insufficientBalance: false,
        failed: false,
        status: "",
        notFound: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        data: action.payload,
      };
    case PENDING_LIST_SUCCESS:
      return {
        ...state,
        failed: false,
        success: true,
        invalidRequest: false,
        insufficientBalance: false,
        status: "",
        notFound: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        data: [].concat(action.payload.PendingRequestMoneyResponse),
      };

    case PENDING_LIST_NOT_FOUND:
      return {
        ...state,
        notFound: true,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        status: "",
        data: action.payload,
      };

    case NETWORK_ERROR_PENDING_LIST:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        notFound: false,
        status: "Something went wrong..",
      };

    case CANCEL_PENDINGLIST_SUCCESS:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: true,
        status: "Request Cancelled",
        data: state.data.filter(
          (res) => res.requestId !== action.payload.requestId
        ),
      };

    case CANCEL_PENDINGLIST_FAILED:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        sendInvReq: false,
        insufficientBalance: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: true,
        cancelSuccess: false,
        status: "Cancel Pending List Failed",
      };

    case CANCEL_PENDINGLIST_INVALID_REQUEST:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: true,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        status: "",
      };

    case NETWORK_ERROR_CANCEL_PENDING_LIST:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        status: "Something went wrong..",
      };

    case SEND_PENDINGLIST_SUCCESS:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: true,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        status: "",
        successData: action.payload.data,
        data: state.data.filter(
          (res) => res.requestId !== action.payload.requestId
        ),
      };

    case SEND_PENDINGLIST_FAILED:
      return {
        ...state,
        failed: true,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: true,
        cancelFailed: false,
        cancelSuccess: false,
        successData: {},
        status: "Send failed!",
      };

    case SEND_PENDINGLIST_INVALID_REQUEST:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: true,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        successData: {},
        status: "Oops!, something went wrong",
      };

    case SEND_PENDINGLIST_INSUFFICIENT_BALANCE:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: true,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        successData: {},
        status: "Insufficient Balance!",
      };

    case NETWORK_ERROR_SEND_PENDING_LIST:
      return {
        ...state,
        failed: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        sendInvReq: false,
        cancelInvReq: false,
        sendSuccess: false,
        sendFailed: false,
        cancelFailed: false,
        cancelSuccess: false,
        status: "Something went wrong..",
      };

    case RESET_SEND_PENDING_LIST:
      return {
        ...state,
        sendSuccess: false,
        sendFailed: false,
        insufficientBalance: false,
        sendInvReq: false,
        successData: {},
      };

    case RESET_CANCEL_PENDING_LIST:
      return {
        ...state,
        cancelSuccess: false,
        cancelFailed: false,
        cancelInvReq: false,
      };

    case RESET_PENDING_LIST:
      return (state = initialState);

    default:
      return state;
  }
};
